var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntercomIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "7 3 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 28342",
    filter: "url(#filter0_dd_2704_49784)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 48",
    x: 8,
    y: 4,
    width: 62,
    height: 62,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 23.9916C56 21.759 54.241 20 52.0084 20H27.9916C25.759 20 24 21.8267 24 23.9916V48.009C24 50.2416 25.8266 52 27.9916 52H52.0084C54.241 52 56 50.1739 56 48.009V23.9916ZM28.2621 27.9832V37.5902C28.2621 38.1998 28.7357 38.6734 29.3446 38.6734C29.9535 38.6734 30.4271 38.199 30.4271 37.5902V27.9832C30.4271 27.3744 29.9535 26.9008 29.3446 26.9008C28.7357 26.9008 28.2621 27.3744 28.2621 27.9832ZM33.6068 40.0935V25.8183C33.6068 25.2094 34.0803 24.7358 34.6892 24.7358C35.2981 24.7358 35.7717 25.2094 35.7717 25.8183V40.0935C35.7717 40.7024 35.2981 41.176 34.6892 41.176C34.0803 41.176 33.6068 40.7029 33.6068 40.0935ZM38.9514 25.2771V40.77C38.9514 41.3796 39.4249 41.8525 40.0338 41.8525C40.6428 41.8525 41.1162 41.3788 41.1162 40.77V25.2771C41.1162 24.6682 40.6428 24.1946 40.0338 24.1946C39.4249 24.1946 38.9514 24.6682 38.9514 25.2771ZM44.2959 40.0935V25.8183C44.2959 25.2094 44.7695 24.7358 45.3786 24.7358C45.9873 24.7358 46.4609 25.2094 46.4609 25.8183V40.0935C46.4609 40.7024 45.9873 41.176 45.3786 41.176C44.7695 41.176 44.2959 40.7029 44.2959 40.0935ZM51.7379 37.5902V27.9832C51.7379 27.3744 51.2643 26.9008 50.6555 26.9008C50.0465 26.9008 49.5729 27.3744 49.5729 27.9832V37.5902C49.5729 38.1998 50.0465 38.6734 50.6555 38.6734C51.2643 38.6734 51.7379 38.199 51.7379 37.5902ZM51.4673 42.7997C51.873 43.2054 51.8054 43.8822 51.3318 44.2879C51.1967 44.4234 47.2051 47.7385 39.9662 47.7385C32.7273 47.7385 28.7357 44.4239 28.6004 44.2879C28.1268 43.8814 28.1268 43.2049 28.4651 42.7997C28.871 42.3261 29.5476 42.3261 29.9535 42.6642C30.0211 42.7326 33.5391 45.6411 39.9662 45.6411C46.4609 45.6411 49.9113 42.7321 49.9789 42.6642C50.4525 42.2585 51.1291 42.3261 51.4673 42.7997Z",
    fill: "#061E34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2704_49784",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2704_49784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2704_49784",
    result: "effect2_dropShadow_2704_49784"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2704_49784",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntercomIcon);
export default __webpack_public_path__ + "static/media/intercom-icon.e586ddb88aa7c000d055db959f2992c1.svg";
export { ForwardRef as ReactComponent };